import { SdohDelayReasonOptions } from "@app/feature/referral-manager/components/sdoh-delay-reason-dialog/sdoh-delay-reason-options.enum";

export interface CreateFirstVisitModel {
  subscriberNumber: string;
  providerAccountId: string;
  tenantId: string;
  type: string;
}

export enum VisitsType {
  first = 'First',
  second = 'Second',
  firstNoShow = 'FirstNoShow',
  secondNoShow = 'SecondNoShow',
  thirdNoShow = 'ThirdNoShow'
}

export interface VisitResponse extends VisitCreateRequestBody {
  referralVisitId: string;
  referenceNumber: string;
  visitedOn: string;
  rescheduleReason?: string;
  comment: string;
  createdOn: string;
  createdBy: string;
  modifiedOn: string;
  modifiedBy: string;
  cancelations: VisitCancelResponse[];
  delayReason?: SdohDelayReasonOptions;
  delayOtherReason?: string;
  typeDescription: string;
  isAccepted: boolean;
}

export interface VisitCancelResponse {
  referralVisitId: string;
  referralVisitCancelationId: string;
  facilityAdmissionOn: string;
  reason?: string;
  createdOn: string;
  createdBy: string;
  comment?: string;
}

export interface VisitCreateRequestBody {
  referralId: string;
  type: string;
  delayReason?: SdohDelayReasonOptions;
  delayOtherReason?: string;
}

export interface VisitEdit extends VisitCreateRequestBody {
  referralVisitId: string;
  rescheduleReason: VisitReason;
  rescheduleDate?: string | Date;
  comment?: string;
}

export interface VisitCancel {
  reason: string;
  comment: string;
  facilityAdmissionOn: string;
}

export interface NoShowVisit {
  referralId: string;
  referralVisitId?: string;
  type: string;
  visitedOn: string;
  comment: string;
}

export interface VisitUpdateModel {
  tenantId: string;
  visits: VisitResponse;
}

export enum VisitReason {
  ClinicianNoLongerAvailable = 'Clinician no longer available',
  MemberAdmittedToInpatientFacility = 'Member admitted to Inpatient Facility',
  MemberReadmittedToInpatientFacility = 'Member readmitted to Inpatient Facility',
  MemberRefused = 'Member refused',
  MemberRequestedSpecificVisitDate = 'Member requested specific visit date',
  NoShowAndVisitRescheduled = 'No-show and visit rescheduled',
  UnableToContact = 'Unable to contact',
  UnsafeHomeEnvironment = 'Unsafe home environment',
  Other = 'Other',
  UpdatedInAssessmentForm = 'UpdatedInAssessmentForm',
}
